// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./font-awesome/css/font-awesome.min.css
// module id = 1115
// module chunks = 2